import Markdown from "react-markdown";

interface ParagraphBlockProps {
  text: string;
}

export function ParagraphBlock({ text }: ParagraphBlockProps) {
  return (
    <div className="prose prose-sm max-w-none text-puntt-neutral-gray-11">
      <Markdown>{text}</Markdown>
    </div>
  );
}
